module.exports = __webpack_public_path__ + "img/ic_garansi.b8416643.webp";